import { useMemo } from 'react';

import { useSessionData } from '@confluence/session-data';

export const usePerformanceTrackingOptions = () => {
	const { featureFlags } = useSessionData();

	return useMemo(() => {
		const optionsString = featureFlags['confluence.frontend.fabric.editor.performance-tracking'];
		if (typeof optionsString === 'string') {
			try {
				return JSON.parse(optionsString);
			} catch (err) {
				if (process.env.NODE_ENV !== 'production') {
					// eslint-disable-next-line no-console
					console.error(`Failed to parse performance-tracking`, err);
				}
			}
		}
	}, [featureFlags]);
};
